import React, { FC } from 'react';
import styled from 'lib/styled';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import sv from 'dayjs/locale/sv';
import NoticeIcon from '../components/NoticeIcon';
import NoticeTitle from '../components/NoticeTitle';
import NoticeDate from '../components/NoticeDate';
import NoticeLabel from '../components/NoticeLabel';
import { TicketNotification } from '@app/api/models/Notifications';
import NoticeDescription from '../components/NoticeDescription';
import ThemeIcons from '../../Icon/ThemedIcons';
import { L } from '@app/shared/lib/i18n';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
const Border = styled.div(({ theme }) => {
    return {
        backgroundColor: theme.colors.alertBackground,
        padding: '16px',
        width: '100%',
        borderRadius: '8px',
        display: 'grid',
        whiteSpace: 'pre-line',
        gridTemplateColumns: 'min-content auto min-content',
        gridTemplateAreas: `
    "icon title label"
    "icon description label"
    "icon date label"
    `,
        columnGap: '1rem',
        rowGap: '0.5rem',
    };
});

const InformationNotice: FC<TicketNotification & { isCollapsed: boolean }> = ({
    body,
    title,
    data,
    created_at,
    isCollapsed,
    link,
    ...rest
}) => {
    const notificationDate = created_at && dayjs(created_at).locale(sv).fromNow();

    return (
        <Link to={link ?? `/`}>
            <Border {...rest}>
                <NoticeIcon>
                    <ThemeIcons.Info />
                </NoticeIcon>
                <NoticeTitle isCollapsed={isCollapsed} description={title} />
                <NoticeDescription description={body} />
                <NoticeLabel type={L('content_information')} />
                <NoticeDate when={notificationDate} />
            </Border>
        </Link>
    );
};

export default InformationNotice;
